module.exports = __webpack_public_path__ + "static/img/connect-img-append.e1a84ae1.png";